import React from 'react';
import { useSystemSettings } from '@/hooks/common';
import { useNotification } from '@/hooks/common';
import { AlertMessage } from '@/components/ui/AlertMessage';
import { DomainSettings } from '@/components/settings/environment/superadmin/DomainSettings';
import { SmtpSettings } from '@/components/settings/environment/superadmin/SmtpSettings';

const Settings: React.FC = () => {
  const { success, error, setSuccess, setError } = useNotification({ duration: 5000 });
  const {
    settings,
    setSettings,
    loading,
    error: settingsError,
    setError: setSettingsError,
    saveDomainSettings,
    saveSmtpSettings,
  } = useSystemSettings();

  const handleSettingsChange = (updates: Partial<typeof settings>) => {
    setSettings(prev => ({ ...prev, ...updates }));
  };

  const handleSaveDomain = async (): Promise<string> => {
    try {
      const message = await saveDomainSettings();
      setSuccess(message);
      setSettingsError('');
      return message;
    } catch (error) {
      // Error is handled by hook
      throw error;
    }
  };

  const handleSaveSmtp = async (): Promise<string> => {
    try {
      const message = await saveSmtpSettings();
      setSuccess(message);
      setSettingsError('');
      return message;
    } catch (error) {
      // Error is handled by hook
      throw error;
    }
  };

  const displayError = error || settingsError;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-3xl font-bold text-gray-900">환경설정</h2>
      </div>

      {displayError && (
        <AlertMessage type="error" message={displayError} onClose={() => {
          setError('');
          setSettingsError('');
        }} />
      )}

      {success && (
        <AlertMessage type="success" message={success} onClose={() => setSuccess('')} />
      )}

      <DomainSettings
        settings={settings}
        onSettingsChange={handleSettingsChange}
        onSave={handleSaveDomain}
        loading={loading}
      />

      <SmtpSettings
        settings={settings}
        onSettingsChange={handleSettingsChange}
        onSave={handleSaveSmtp}
        loading={loading}
      />
    </div>
  );
};

export default Settings;

